import confetti from 'canvas-confetti';

export function celebrateSmall() {
  confetti({
    particleCount: 60,
    spread: 60,
    startVelocity: 35,
    origin: { y: 0.6 },
    colors: ['#0054FF', '#F4C542', '#FF3B30', '#28A745']
  });
}

export function celebrateBurst() {
  const end = Date.now() + 600;
  const colors = ['#0054FF', '#F4C542', '#FF3B30', '#28A745'];
  (function frame() {
    confetti({ particleCount: 6, angle: 60, spread: 55, origin: { x: 0 }, colors });
    confetti({ particleCount: 6, angle: 120, spread: 55, origin: { x: 1 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

